import { SearchSource } from '../@types/searchSource';

export const CALCULATOR_FEATURE_NAME = 'fulldeal-calculator-editable';
export const CALCULATOR_FEATURE_NAME_GOOGLE = 'fulldeal-calculator-editable-google';
export const CALCULATOR_FEATURE_NAME_YANDEX = 'fulldeal-calculator-editable-yandex';

export const getCalculatorFeatureNameBySearchSource = (searchSource: SearchSource | null | undefined): string => {
  switch (searchSource) {
    case SearchSource.Google:
      return CALCULATOR_FEATURE_NAME_GOOGLE;
    case SearchSource.Yandex:
      return CALCULATOR_FEATURE_NAME_YANDEX;
    default:
      return CALCULATOR_FEATURE_NAME;
  }
};
